import React, { useEffect, useState } from 'react'
import { Label } from '../../../../../components/ui/label'
import { Combobox } from '../../../../../components/ui/combobox'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux';
import { Toaster, toast } from 'react-hot-toast';
import axios from '../../../../../lib/axios'
import useAuth from '../../../../../hooks/useAuth';
import { Input } from '../../../../../components/ui/input';
import { Button } from '../../../../../components/ui/button';
import PlannedStopsCalendar from '../../../../../components/portal/stop/PlannedStopsCalendar';
import { format, isBefore, isSameMonth, isToday, isValid, subMonths } from 'date-fns';
import { DayObject } from '../../../../../components/portal/stop/calendar/Calendar';
import { combineCNValues, formatCashAmount } from '../../../../../lib/utils';
import { Loader2, Search, Trash } from 'lucide-react';
import { Tooltip, TooltipProvider, TooltipTrigger, TooltipContent } from '../../../../../components/ui/tooltip';
import { AlertDialog, AlertDialogContent, AlertDialogTrigger } from '../../../../../components/ui/alert-dialog';
import { AlertDialogCancel } from '@radix-ui/react-alert-dialog';
import TooltipForce from '../../../../../components/ui/tooltip-force';
import { convertToDate, formatDateToYYYYMMDD } from '../../../../../lib/date';
import { useQuery } from '@tanstack/react-query';
import { isKeepsafeMother } from '../../../../../lib/general/keepsafe';
import { getCustomerList } from '../../../../../lib/fetch/customer';
import { useTranslation } from 'react-i18next';
import ReactGA from "react-ga4";
import { CONFIG } from '../../../../../config';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../../../../../components/ui/select';
import NewKeepsafeForeignCurrency from '../../../../../components/portal/announcement/NewKeepsafeForeignCurrency';
import EditKeepsafeForeignCurrency from '../../../../../components/portal/announcement/EditKeepsafeForeignCurrency';
import AddKeepsafeForeignCurrency from '../../../../../components/portal/announcement/AddKeepsafeForeignCurrency';
import CoupureForeignCurrency from '../../../../../components/portal/coupure/CoupureForeignCurrency';

type Props = {
    defaultDraft?: AnnouncementDraftSearch
    defaultPartner?: string | null;
    defaultCustomer?: string | null;
}

const AnnounceForeignCurrencyForm = ({defaultDraft, defaultPartner, defaultCustomer}:Props) => {
    const {auth} = useAuth()
    const {t} = useTranslation()
    const partners = useSelector((state:RootState)=>state.partners);

    const [edit_draft, setedit_draft] = useState<AnnouncementDraftSearch | null>(null);

    const [selected_partner, setselected_partner] = useState<string | null>(null);
    const [selected_customer, setselected_customer] = useState<string | null>(null);
    const [customers_list, setcustomers_list] = useState<Customer[] | null>();
    const [selectedDate, setselectedDate] = useState<Date | undefined>();
    const [reference, setreference] = useState<string>('');
    const [selected_currency, setselected_currency] = useState<string | undefined>(undefined);
    const [devies_currencies, setdevies_currencies] = useState<DeviesCurrency[]>([]);

    const [selectedEvent, setselectedEvent] = useState<DayObject | null>(null);

    const [keepsafes, setkeepsafes] = useState<AnnouncementKeepsafeForeignCurrency[]>([]);
    
    const { refetch } = useQuery<AnnouncementDraftSearch[] | null>({
      queryKey:['announcement_concept'], 
      queryFn: async () => {
          try {
              const object = {
                  token: auth.data?.token,
                  startdate: formatDateToYYYYMMDD(subMonths(new Date(), 1)),
                  enddate: formatDateToYYYYMMDD(new Date()),
                  partner: auth.data?.partner,
                  searchby: 'C',
                  status: '001'
              }
              const { data } = await axios.post(`announcement/draft/search`, object)
              if(data.errorcode === 0 && Array.isArray(data.object.announcementdraft)){
                  return data.object.announcementdraft;
              }
              else {
                //if(data.errorcode === 0){ toast.error('Geen concepten gevonden'); return null; }
                console.log("No concepts")
              }
          } catch (error) {
            toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_error"))              
          }
          return null;
      }
    })

    const { refetch:refetchPrevious } = useQuery<AnnouncementDraftSearch[] | null>({
      queryKey: ['announcement_previous'],
      queryFn: async () => {
          try {
              const object = {
                  token: auth.data?.token,
                  startdate: formatDateToYYYYMMDD(subMonths(new Date(), 1)),
                  enddate: formatDateToYYYYMMDD(new Date()),
                  partner: auth.data?.partner,
                  status: '002',
                  searchby: 'C'
              }
              const { data } = await axios.post(`announcement/draft/search`, object)
              if(data.errorcode !== 0) { throw new Error(data.message)}
              else {
                  if(!Array.isArray(data.object.announcementdraft)) { return [] }
                  return data.object.announcementdraft
              }
          } catch (error) {
              toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p2"))
          }
      },
      enabled:false
    })

    useEffect(()=>{
      if(defaultDraft) {
        const getDetail = async () => {
          try {
            const {data} = await axios.post(`announcement/draft/detail`, { token: auth.data?.token, id: defaultDraft.id})
            if(data.errorcode === 0) { 
              setselectedEvent({date:convertToDate(defaultDraft.date) || new Date(), isSameMonth:isSameMonth(new Date(), convertToDate(defaultDraft.date) || new Date()), isToday:isToday(convertToDate(defaultDraft.date) || new Date()), isSelected:true, isBeforeToday:isBefore(convertToDate(defaultDraft.date) || new Date(), new Date()), day:format(convertToDate(defaultDraft.date) || new Date(), "d"), events:[]})
              let ks:AnnouncementKeepsafeForeignCurrency = {keepsafe:defaultDraft.keepsafe,detail:[]}
              ks.detail = data.object.detail;
              setkeepsafes([ks])
            }
            else { console.log(data) }
          } catch (error) {
            console.log(error);
          }
        }
        setedit_draft(defaultDraft)
        getDetail();

        setselected_currency(defaultDraft.deviescurrencyid?.toString() || undefined)
        setselected_customer(defaultDraft.relnr.toString())
        setselectedDate(convertToDate(defaultDraft.date) || undefined) 
        setreference(defaultDraft.reference) 
      }
    }, [defaultDraft])

    useEffect(()=>{
        if(!defaultPartner) return;
        ;(async () => {
            await handlePickPartner(defaultPartner)
            if(defaultCustomer) setselected_customer(defaultCustomer)
        })()
    }, [defaultPartner, defaultCustomer])

    useEffect(()=>{
      if (auth.data?.partner && auth.data?.partner.split(",").length === 1) {
        handlePickPartner(auth.data.partner.split(",")[0])
      }
    }, [])

    const handlePickPartner = async (relnr:string) => {
        try {
          if(selected_partner!==relnr){setselected_customer('clear')}
          setselected_partner(relnr);
          setcustomers_list(null);
          setdevies_currencies([]);
          
          const list = await getCustomerList(auth, relnr)
          if(list){ setcustomers_list(list) }
          if(list.length === 1){ setselected_customer(list[0].relnr.toString()) }

        } catch (error) {
          console.log(error)
          toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_wrong"))
        }

        try {
            const { data:kassa } = await axios.get(`kassa/get`, {
                params: {
                    token: auth.data?.token,
                    relnr: relnr
                }
            })
            if(kassa.errorcode !== 0){ throw new Error(kassa.message) }
            if(!Array.isArray(kassa.object)) { console.log('geen deviescurrency ingesteld'); throw new Error() }
            
            const merged: Record<number, any> = {}
            kassa.object.forEach((k:any) => {
                k.deviescurrency.filter((dc:any) => dc.currencyactive).forEach((dc:any) => {
                    if (!merged[dc.deviescurrencyid]) {
                        merged[dc.deviescurrencyid] = { ...dc, devies: [] }
                    }
                    dc.devies.filter((d:any) => d.order && d.deviesactive).forEach((d:any) => {
                        if (!merged[dc.deviescurrencyid].devies.find((x:any) => x.value === d.value && x.cn === d.cn)) {
                            merged[dc.deviescurrencyid].devies.push(d)
                        }
                    })
                })
            })
            const deviesCurrencies = Object.values(merged).filter((dc:any) => dc.devies.length > 0)

            setdevies_currencies(deviesCurrencies)
        } catch (err) {
            console.log(err)
            toast.error('Something went wrong while getting the foreign currency list', { id:'get-foreign-currency-list' })
        }
    }

    const addPochette = (keepsafe:AnnouncementKeepsafeForeignCurrency, pochette:AnnouncemenDetailForeignCurrency) => {
      let tmp = [...keepsafes];
      const index = tmp.findIndex(i => i.keepsafe === keepsafe.keepsafe);
      if(index > -1){
        if(!tmp[index].detail) { tmp[index].detail = []}

        const alreadyExists = tmp[index].detail?.find(i=>i.bag.toLowerCase() === pochette.bag.toLowerCase())
        if(alreadyExists) { toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_exists")); return; }

        tmp[index].detail?.push(pochette)
        setkeepsafes(tmp)
        toast.success(t("order_and_pickup.o_announce_pickup.o_manual.toast_success"))
      }
      else {
        toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p3"))
      }
    }

    const deleteKeepsafe = (keepsafe:AnnouncementKeepsafeForeignCurrency) => {
      let tmp = [...keepsafes]
      const index = tmp.indexOf(keepsafe)
      if(index > -1){
        tmp.splice(index, 1)
        setkeepsafes(tmp)
        toast.success(t("order_and_pickup.o_announce_pickup.o_manual.toast_success_p2"))
      }
      else {
        toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p4"))
      }
    }

    const deletePochette = (keepsafe:AnnouncementKeepsafeForeignCurrency, detail:AnnouncemenDetailForeignCurrency) => {
      let tmp = [...keepsafes]
      const index = tmp.indexOf(keepsafe)
      if(index > -1 && tmp[index].detail){
        const sub_index = tmp[index].detail?.indexOf(detail);
        if(sub_index === undefined) { toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p5")); return; }
        if(sub_index > -1){
          tmp[index].detail?.splice(sub_index, 1)
          setkeepsafes(tmp)
          toast.success(t("order_and_pickup.o_announce_pickup.o_manual.toast_success_p3"))
        }
        else {
          toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p5"))
        }
      }
      else {
        toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p5"))
      }
    }

    const editKeepsafe = (og:AnnouncementKeepsafeForeignCurrency, nw:AnnouncementKeepsafeForeignCurrency) => {
      let tmp = [...keepsafes];
      const index = tmp.indexOf(og);
      if(index > -1){
        tmp[index].keepsafe = nw.keepsafe;
        tmp[index].detail = nw.detail;
        setkeepsafes(tmp)
      }
      else {
        toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_no_found"))
      }
    }

    const editPochette = (ks:AnnouncementKeepsafeForeignCurrency, dt:AnnouncemenDetailForeignCurrency, nw:AnnouncemenDetailForeignCurrency) => {
      let tmp = [...keepsafes];
      const index = tmp.indexOf(ks);
      if(index > -1){
        const sub_index = tmp[index].detail?.indexOf(dt);
        if(sub_index === undefined){return;}
        if(sub_index > -1){
          // @ts-ignore
          tmp[index].detail[sub_index].bag = nw.bag; tmp[index].detail[sub_index].coupures = nw.coupures;
          
          setkeepsafes(tmp)
        }
        else {
          toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_no_found_p2"))
        }
      }
      else {
        toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_no_found"))
      }
    }

    const [is_saving, setis_saving] = useState(false);
    const onSave = async () => {
      try {
        setis_saving(true)
        if(!selectedDate) { toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_no_date"), {duration:5000}); return;}
        let status:{fail:AnnouncementKeepsafeForeignCurrency[], success:AnnouncementKeepsafeForeignCurrency[]} = {fail:[], success:[]}
        let results:any = []

        const promises = keepsafes.map(async (keepsafe, index) => {
          try {
            
            if(!selectedDate) { toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_no_date"), { id:'saveDraft', duration:5000}); return; }
            if(!isValid(selectedDate)){ toast.error(`${t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p10")}`, { id:'saveDraft', duration:5000 }); return; }
            if(isBefore(selectedDate, new Date)){ toast.error(`${t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p11")}`, { id:'saveDraft', duration:5000 }); return; }

            const isCN = selectedDevies?.devies.find(d => d.value === keepsafe.detail[0].coupures[0].coupure)?.cn as 'c' | 'n' | undefined
            if(!isCN){ toast.error('Error while getting CN type'); return; }

            const object = {
              valuta: selected_currency,
              token: auth.data?.token,
              relnr: selected_customer,
              cn: isKeepsafeMother(keepsafe) ? 'n' : isCN,
              date: formatDateToYYYYMMDD(selectedDate),
              reference: reference,
              ...keepsafe
            }
            const { data } = await axios.post(`announcement/draft/create`, object)
            if(data.errorcode === 0) {
              results.push(data.object)
              status.success.push(keepsafe)
            }
            else {
              throw new Error(data.message)
            }
          } catch (err) {
            status.fail.push(keepsafe)
            console.log(err)
          }
        })

        toast.loading(t("order_and_pickup.o_announce_pickup.o_manual.toast_loading"), { id:'saveDraft' })

        await Promise.all(promises);

        //Concept keepsafes saved
        //if(status.success.length === keepsafes.length) { refetch(); toast.success('Concept opgeslagen', { id:'saveDraft', duration:5000 }) }
        if(status.fail.length > 0) { status.fail.forEach(keepsafe => toast.error(`${keepsafe.keepsafe} ${t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p6")}`, { duration:5000 })) }

        const promiseValidating = results.map(async (obj:any, index:number) => {
          try {
            const {data} = await axios.post(`announcement/draft/validate`, { token:auth.data?.token, id:obj.id })
            if(data.errorcode!==0){throw new Error(data.message)}
            console.log(data, obj)
          } catch (error) {
            toast.error(`${t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p7")} ${obj.id} ${t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p6")}`)
          }
        })

        await Promise.all(promiseValidating);

        refetchPrevious()
        toast.success(t("order_and_pickup.o_announce_pickup.o_manual.toast_success_p4"), { id:'saveDraft' })
        setkeepsafes([])
        ReactGA.event({
          category: 'Announcements',
          action: 'announcement_success',
        })
      } catch (error) {
        ReactGA.event({
          category: 'Announcements',
          action: 'announcement_failed',
        })
      } finally {
        setis_saving(false)
      }
    }

    const onSaveEditDraft = async () => {
      try {
        if(!selectedDate) { toast.error('No date selected!', {duration:5000}); return;}
        const isCN = selectedDevies?.devies.find(d => d.value === keepsafes[0].detail[0].coupures[0].coupure)?.cn as 'c' | 'n' | undefined
        if(!isCN){ toast.error('Error while getting CN type'); return; }

        toast.loading(t("order_and_pickup.o_announce_pickup.o_manual.toast_loading_p2"), { id:'onSaveEditDraft' })
        const {data} = await axios.post(`announcement/draft/update`, {
          valuta: selected_currency,
          token: auth.data?.token,
          id: edit_draft?.id,
          relnr: selected_customer,
          cn: isCN,
          date: formatDateToYYYYMMDD(selectedDate),
          reference: reference,
          ...keepsafes[0]
        })

        if(data.errorcode === 0){
          toast.success(t("order_and_pickup.o_announce_pickup.o_manual.toast_success_p5"), { id:'onSaveEditDraft' })
          setkeepsafes([])
          setedit_draft(null)
          refetch();
          ReactGA.event({
            category: 'Announcements',
            action: 'announcement_update_success',
          })
        } else {
          console.log(data);
          toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p8"), { id:'onSaveEditDraft' })
        }

        
      } catch (error) {
        console.log(error);
        toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p8"), { id:'onSaveEditDraft' })
        ReactGA.event({
          category: 'Announcements',
          action: 'announcement_update_failed',
        })
      }
    }

    const onSaveDraft = async () => {
      let status:{fail:AnnouncementKeepsafeForeignCurrency[], success:AnnouncementKeepsafeForeignCurrency[]} = {fail:[], success:[]}
      const promises = keepsafes.map(async (keepsafe, index) => {
        try {

          const isCN = selectedDevies?.devies.find(d => d.value === keepsafe.detail[0].coupures[0].coupure)?.cn as 'c' | 'n' | undefined
          if(!isCN){ toast.error('Error while getting CN type'); return; }
          
          if(!selectedDate) { toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_no_date"), { id:'saveDraft', duration:5000}); return;}
          const object = {
            valuta: selected_currency,
            token: auth.data?.token,
            relnr: selected_customer,
            cn: isKeepsafeMother(keepsafe) ? 'n' : isCN,
            date: formatDateToYYYYMMDD(selectedDate),
            reference: reference,
            ...keepsafe
          }
          const { data } = await axios.post(`announcement/draft/create`, object)
          if(data.errorcode === 0) {
            status.success.push(keepsafe)
            ReactGA.event({
              category: 'Announcements',
              action: 'announcement_draft_success',
            })
          }
          else {
            throw new Error(data.message)
          }
        } catch (err) {
          status.fail.push(keepsafe)
          console.log(err)
          ReactGA.event({
            category: 'Announcements',
            action: 'announcement_draft_failed',
          })
        }
      })

      toast.loading(t("order_and_pickup.o_announce_pickup.o_manual.toast_loading_p3"), { id:'saveDraft' })

      await Promise.all(promises);

      if(status.success.length === keepsafes.length) { refetch(); toast.success(t("order_and_pickup.o_announce_pickup.o_manual.toast_success_p6"), { id:'saveDraft', duration:5000 }) }
      else { 
        status.fail.forEach(keepsafe => toast.error(`${keepsafe.keepsafe} ${t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p6")}`, { id:'saveDraft', duration:5000 }))
      }
      setkeepsafes([])
    }

    const calculateTotal = (coupures:{qty:number, coupure:number}[] | undefined) => {
      let total = 0;
  
      if(coupures && selectedDevies) {
          let tmp = [...coupures]
          
          let cn = selectedDevies.devies.find(i=>i.value === coupures[0].coupure)?.cn || 'n';
          

          const c_devies = selectedDevies.devies.filter(i=>i.cn.toLowerCase() === 'c')
          const n_devies = selectedDevies.devies.filter(i=>i.cn.toLowerCase() === 'n')

          if(cn === 'c'){
              tmp = tmp.filter(i => c_devies.findIndex(d => d.value === i.coupure) > -1)
          } else {
              tmp = tmp.filter(i => n_devies.findIndex(d => d.value === i.coupure) > -1)
          }            
  
          tmp.forEach(item => {
              if(!isNaN(item.qty) && !isNaN(item.coupure)){
                  total += item.qty * item.coupure
              }
          });
      }
  
      return total;
    }

    function isRequiredReference () {
      if(!selected_partner){ return false }
      const includes = CONFIG.order_and_collect.collect.requiredReference_relnrs.includes(selected_partner)
      return includes
    }
  
    function isComplete() {
      const requiredRef = isRequiredReference()
      if(requiredRef){
        if(reference.length < 1){ return false }
      }
      if(!selected_partner){ return false; }
      if(!selected_customer){ return false; }

      return true
    }

    let partnersArr = Array.isArray(partners) ? (partners.map((item) => ({value:item.relnr, label:item.name}))) : []
    partnersArr.length > 0 && partnersArr.unshift({value:parseFloat(process.env.REACT_APP_RDM_NUM!), label:t("components.o_partners_ddl.no_partner")})

    let customersArr = Array.isArray(customers_list) ? customers_list.map((item)=> ({value:item.relnr, label:`${item.name} - ${item.clientcode}`})) : []

    const currencyOptions = Array.isArray(devies_currencies) ? devies_currencies.map(dc=>({value:dc.deviescurrencyid, label:dc.deviescurrencyname})) : []

    const selectedDevies = devies_currencies.find(i=>i.deviescurrencyid.toString() === selected_currency)

  return (
    <>
    <Toaster />
    <div className='grid grid-cols-[repeat(auto-fit,minmax(300px,1fr))] gap-4'>
        <div>
            <Label htmlFor='partner'>{t("order_and_pickup.o_announce_pickup.o_manual.partner")}</Label>
            <Combobox disabled={partners?.length === 1} id='partner' selectedValue={selected_partner ? selected_partner : undefined} onValueChange={(value) => { handlePickPartner((value.value).toString()) }} options={partnersArr} placeholder={t("order_and_pickup.o_announce_pickup.o_manual.partner_placeholder") || ""} input_placeholder={t("order_and_pickup.o_announce_pickup.o_manual.search_placeholder") || ""}/>
        </div>

        <div>
            <Label htmlFor='end_customer'>{t("order_and_pickup.o_announce_pickup.o_manual.customer")}</Label>
            <Combobox disabled={!Array.isArray(customers_list)} selectedValue={selected_customer ? selected_customer : undefined} id='end_customer' onValueChange={(value) => { setselected_customer(value.value.toString()) }} options={customersArr} placeholder={t("order_and_pickup.o_announce_pickup.o_manual.customer_placeholder") || ""} input_placeholder={t("order_and_pickup.o_announce_pickup.o_manual.search_placeholder") || ""}/>
        </div>

        <div>
            <Label>{t("order_and_pickup.o_announce_pickup.o_manual.date")}</Label>
            <PlannedStopsCalendar page='announce' onSelectDay={(v)=>{setselectedEvent(v)}} disabled={!(selected_partner !== null && selected_customer !== null) || selected_customer === 'clear'} partnerid={selected_partner ? parseFloat(selected_partner) : 0} clientrelnr={selected_customer ? parseFloat(selected_customer) : 0} setselectedDate={setselectedDate} selectedDate={selectedDate}/>
        </div>

        <div>
            <Label htmlFor='valuta' className='flex items-center gap-1 mb-1'>{t("order_and_pickup.o_announce_pickup.valuta_label")}</Label>
            <Select value={selected_currency} onValueChange={(value)=>{setselected_currency(value.toString())}}>
                <SelectTrigger id='valuta' className='gap-2 font-medium'><SelectValue placeholder={t("order_and_pickup.o_announce_pickup.valuta_placeholder")||""}/></SelectTrigger>
                <SelectContent>
                    {currencyOptions.map((option,i)=>(
                        <SelectItem key={i} value={option.value.toString()}>{option.label}</SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>

        <div>
            <Label htmlFor='reference' className='flex items-center gap-1 mb-1'>{t("order_and_pickup.o_announce_pickup.o_manual.reference")}{isRequiredReference() && <span className='text-primary'>*</span>}</Label>
            <Input value={reference} onChange={({currentTarget})=>{ setreference(currentTarget.value) }}/>
        </div>
    </div>
    
    {(selectedEvent && selectedDevies && !edit_draft) && <NewKeepsafeForeignCurrency devies_currencies={selectedDevies} onSave={(keepsafe)=>{if(!keepsafes.find(i => i.keepsafe === keepsafe.keepsafe)){setkeepsafes(prev => [...prev, keepsafe]); toast.success(t("order_and_pickup.o_announce_pickup.o_manual.toast_success_p7"))} else{ toast.error(t("order_and_pickup.o_announce_pickup.o_manual.toast_error_p9")) } }} cn={combineCNValues(selectedEvent?.events).toLowerCase()} selectedDate={selectedEvent.date}/>}

    {(keepsafes && selectedEvent) && Array.isArray(keepsafes) && keepsafes.length > 0 &&
    <div className='mt-4'>
      <h2 className='text-lg'>{t("order_and_pickup.o_announce_pickup.o_manual.subtitle")} ({keepsafes.length})</h2>

      <div className='flex flex-col gap-2'>
      {keepsafes.map((keepsafe, index) => {
        return (
          <div className='p-2 duration-200 border rounded-sm hover:border-primary' key={index}>
            <div className='grid grid-cols-3'>

              <div className='flex items-center gap-2'>
                {(keepsafe.detail.length < 1) && <button onClick={()=>{deleteKeepsafe(keepsafe)}} className='flex items-center justify-center w-8 h-8 opacity-50 hover:opacity-100 hover:text-red-500'><Trash className='w-5'/></button>} 
                <p>{t("order_and_pickup.o_announce_pickup.o_manual.serial")}: <span className='font-medium'>{keepsafe.keepsafe}</span></p>
                {(isKeepsafeMother(keepsafe) && selectedDevies) && <AddKeepsafeForeignCurrency selected_devies={selectedDevies} onSave={(pochette)=>{ addPochette(keepsafe, pochette) }} cn={'n'} mother_keepsafe={keepsafe}/>}

                {/* Hardcoded op cn => Lander zei dat kind enkel N kan zijn zie state vanboven */}
                {/* {!keepsafe.coupures && <AddKeepsafe onSave={(pochette)=>{ addPochette(keepsafe, pochette) }} cn={combineCNValues(selectedEvent?.events).toLowerCase()} mother_keepsafe={keepsafe}/>} */}
              </div>

              {!isKeepsafeMother(keepsafe) &&
              <>
              <div className='flex items-center'>
                <p>{t("order_and_pickup.o_announce_pickup.o_manual.contents")}: <span className='font-medium'>{formatCashAmount(calculateTotal(keepsafe.detail[0].coupures))} {selectedDevies?.deviescurrencyname}</span></p>
              </div>

              <div className='flex justify-end'>
                <div className='grid grid-cols-3 w-fit'>
                  <TooltipProvider delayDuration={0}>
                    <ActionButton coupure={keepsafe.detail[0].coupures} variant='view' deviesCurrency={selectedDevies}/>
                    <ActionButton deviesCurrency={selectedDevies} onEdit={(newObject)=>{editKeepsafe(keepsafe, {keepsafe:newObject.barcode, detail:[{bag:newObject.barcode, coupures:newObject.coupures}]})}} keepsafe={keepsafe} variant='edit'/>
                    <ActionButton onDelete={()=>{deleteKeepsafe(keepsafe)}} variant='delete'/>
                  </TooltipProvider>
                </div>
              </div>
              </>
              }

            </div>
            
            {keepsafe.detail && 
            <div className='flex flex-col gap-2'>
            {isKeepsafeMother(keepsafe) 
            &&
            <>
            {keepsafe.detail.map((detail, ind) => {
              return (
                <div id="card" className='grid items-center grid-cols-3 p-2 border rounded-sm' key={ind}>
                  <p>{t("order_and_pickup.o_announce_pickup.o_manual.serial")}: <span className='font-medium'>{detail.bag}</span></p>
                  <p>{t("order_and_pickup.o_announce_pickup.o_manual.contents")}: <span className='font-medium'>{formatCashAmount(calculateTotal(detail.coupures))} {selectedDevies?.deviescurrencyname}</span></p>
                  <div className='flex justify-end'>
                    <TooltipProvider delayDuration={0}>
                      <ActionButton coupure={detail.coupures} variant='view' deviesCurrency={selectedDevies}/>
                      <ActionButton deviesCurrency={selectedDevies} onEdit={(newObject)=>{editPochette(keepsafe, detail, {bag:newObject.barcode, coupures:newObject.coupures})}} keepsafe={{keepsafe:detail.bag, detail:[{bag:detail.bag,coupures:detail.coupures}]}} variant='edit'/>
                      <ActionButton onDelete={()=>{deletePochette(keepsafe, detail)}} variant='delete'/>
                    </TooltipProvider>
                  </div>
                </div>
              )
            })}
            </> 

            }     
            </div>
            }
          </div>
        )
      })}
      </div>

      <div className='flex pt-4 mt-4 border-t'>
        {!edit_draft
        ? <Button disabled={!isComplete() || is_saving} onClick={()=>{onSave()}}>{is_saving ? <Loader2 className='animate-spin'/> : t("order_and_pickup.o_announce_pickup.o_manual.button_save")}</Button>
        : <><Button disabled={!isComplete()} onClick={()=>{onSaveEditDraft()}}>{t("order_and_pickup.o_announce_pickup.o_manual.button_save_edit")}</Button><Button onClick={()=>{setedit_draft(null); setkeepsafes([])}} variant='ghost'>{t("order_and_pickup.o_announce_pickup.o_manual.button_cancel")}</Button></>
        }
        
        {!edit_draft && <Button onClick={()=>{onSaveDraft()}} variant='link'>{t("order_and_pickup.o_announce_pickup.o_manual.button_concept")}</Button>}
      </div>
    </div>
    }
    </>
  )
}

type ActionButtonProps = {
  variant: 'view' | 'edit' | 'delete',
  coupure?: CoupureInputForeignCurrency[],
  onDelete?: () => void;
  onEdit?: (object:{barcode:string, coupures:{qty:number, coupure:number}[]}) => void;
  keepsafe?: AnnouncementKeepsafeForeignCurrency
  deviesCurrency?: DeviesCurrency
}

const ActionButton : React.FC<ActionButtonProps> = ({variant, coupure, onDelete, keepsafe, onEdit, deviesCurrency}) => {
  const {t} = useTranslation()
  return (
    <Tooltip>
      {variant === 'view' && <><ActionView coupure={coupure} deviesCurrency={deviesCurrency}/></>}
      {(variant === 'edit' && deviesCurrency) && <><EditKeepsafeForeignCurrency deviesCurrency={deviesCurrency} onSave={(object)=>{onEdit && onEdit(object)}} keepsafe={keepsafe}/></>}
      {variant === 'delete' && <><TooltipTrigger asChild><button onClick={()=>{onDelete && onDelete()}} className='flex items-center justify-center w-8 h-8 duration-200 opacity-50 hover:opacity-90 group'><Trash className='w-5 group-hover:text-red-500'/></button></TooltipTrigger><TooltipContent>{t("order_and_pickup.o_announce_pickup.o_manual.tooltip_delete")}</TooltipContent></>}
    </Tooltip>
    )
}

type ActionViewProps = {coupure?: CoupureInputForeignCurrency[], deviesCurrency?:DeviesCurrency}
const ActionView : React.FC<ActionViewProps> = ({coupure, deviesCurrency}) => {
  const {t} = useTranslation()

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>

        <TooltipForce content={<p className='whitespace-nowrap'>{t("order_and_pickup.o_announce_pickup.o_manual.tooltip_view")}</p>}>
          <button className='flex items-center justify-center w-8 h-8 duration-200 opacity-50 hover:opacity-90 group'><Search className='w-5 group-hover:text-blue-500'/></button>
        </TooltipForce>

      </AlertDialogTrigger>
      <AlertDialogContent>
        <h2 className='text-lg'>{t("order_and_pickup.o_announce_pickup.o_manual.view_title")}</h2>
        <div className='border rounded-sm'>
          <div className='grid grid-cols-3 p-2 border-b bg-slate-100'>
            <i></i>
            <p>{t("order_and_pickup.o_announce_pickup.o_manual.count")}</p>
            <p>{t("order_and_pickup.o_announce_pickup.o_manual.total")}</p>            
          </div>
          <div className='flex flex-col gap-2 p-2'>
            {coupure && <CoupureForeignCurrency deviesCurrency={deviesCurrency} cn={deviesCurrency?.devies.find(i=>i.value === coupure[0].coupure)?.cn.toLowerCase() as 'c' | 'n' || 'c'} coupures={coupure} show_total/> }
          </div>
        </div>
        <AlertDialogCancel asChild>
          <Button variant='secondary'>{t("order_and_pickup.o_announce_pickup.o_manual.close")}</Button>
        </AlertDialogCancel>
      </AlertDialogContent>
    </AlertDialog>
  )
}


export default AnnounceForeignCurrencyForm